import React from 'react';
import styles from '../../../assets/css/login/login.module.css';
import images from '../../../assets/images';
import PropTypes from 'prop-types';

const Login = ({ children }) => {
    return (
        <>
            <div className={styles.login__container}>
                <div className={styles.contenLogo}>
                    <>
                        <a href="#!" className={styles.logo}>
                            <img
                                src={images.logoCampfireSocialColorContent}
                                alt="CampfireSocial"
                            />
                            {/* <p className={styles.logotype}>
                                    CampfireSocial
                                </p> */}
                        </a>
                        <p className={styles.logotype_2}>
                            <span>Own the voice</span> of your industry
                        </p>
                    </>
                </div>
                <div className={styles.login__body}>{children}</div>
            </div>
        </>
    );
};
Login.propTypes = {
    children: PropTypes.node.isRequired,
    nameOrganization: PropTypes.string
};
export default Login;
